import { render, staticRenderFns } from "./BankAccountsEditor.vue?vue&type=template&id=62bc03f0"
import script from "./BankAccountsEditor.vue?vue&type=script&lang=js"
export * from "./BankAccountsEditor.vue?vue&type=script&lang=js"
import style0 from "./BankAccountsEditor.vue?vue&type=style&index=0&id=62bc03f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports